import { render, staticRenderFns } from "./base.vue?vue&type=template&id=4a91d1d7&scoped=true&"
import script from "./base.vue?vue&type=script&lang=js&"
export * from "./base.vue?vue&type=script&lang=js&"
import style0 from "./base.vue?vue&type=style&index=0&id=4a91d1d7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a91d1d7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\xingxingzu\\multi_merchant_web\\supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a91d1d7')) {
      api.createRecord('4a91d1d7', component.options)
    } else {
      api.reload('4a91d1d7', component.options)
    }
    module.hot.accept("./base.vue?vue&type=template&id=4a91d1d7&scoped=true&", function () {
      api.rerender('4a91d1d7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/goods/child/base.vue"
export default component.exports